// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__2HDAL","balanceDisclaimer":"posDashboard_balanceDisclaimer__3R9dt"};